import Vue from "vue"
import VueRouter from "vue-router"
import store from "@/store";

Vue.use(VueRouter);
const routes = [
    {
        path: "/",
        name: "home",
        redirect: "orders/tracking",
    },
    {
        path: "/authentication/login",
        name: "login",
        component: () => import("@/views/authentication/Login.vue")
    },
    {
        path: "/orders/tracking",
        name: "orders/tracking",
        component: () => import("@/views/orders/tracking/Index.vue")
    },
    {
        path: "/inventory",
        name: "inventory",
        component: () => import("@/views/inventory/Index.vue")
    },
    {
        path: "/manufacturers",
        name: "manufacturers",
        component: () => import("@/views/manufacturers/Index.vue")
    },
    {
        path: "/manufacturers/:id",
        name: "manufacturers/view",
        component: () => import("@/views/manufacturers/View.vue")
    },
    {
        path: "/users",
        name: "users",
        component: () => import("@/views/manufacturers/Index.vue")
    },
    {
        path: "/public/tracking/:slug/:purchaseOrderNumber?",
        name: "public/tracking",
        component: () => import("@/views/public/Tracker.vue")
    }
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
});

router.beforeEach((to, from, next) => {
    if (to.name != "login" && !to.name?.startsWith("public/")) {
        if (store.state.user == null) {
            next({ name: "login" });
            return;
        }
    }

    next();
});

export default router;
